module.exports = __webpack_public_path__ + "static/fonts/NanumSquareR.1d20321.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareR.eot
// module id = taE2
// module chunks = 1